import { setLogin, getStateHeadingData, getBeneficiary, getPartenaire, getCountryData, sendOtpSignOn, otpVerification } from '../api/api';
import { setBeneficiary } from './beneficiary';
import { getStateHeadings } from './Dashboard';
import { setPartenaire } from "./partenaire";
import { setCountry } from "./country";
import uuid from 'uuid';
import { history } from '../routers/AppRouter';
import { setMessage } from './messageManagment';

// -------------- LOGIN -------------- //
export const login = (uid) => ({
  type: 'LOGIN',
  uid
});

export const startLogin = (credentials) => {
  const defaultID = btoa(`${credentials.userName}|${credentials.password}|${credentials.memoryCharged}|${window.location.origin}`);
  sessionStorage.defaultID = defaultID;
  return (dispatch) => {
    return setLogin(credentials).then((response) => {
      console.log('inside login', response);
      let isOTPSend = false;
      if (!response || response.status === 401 || response.ok === false) {
        throw new Error('Invalid credentials');
      } else {
        sendOtpSignOn(credentials).then((response) => {
          if (!response || response.status === 401 || response.ok === false) {
            throw new Error('Invalid credentials');
          } else {
            isOTPSend = true;
          }
        }).catch((error) => {
          console.log('--OTP Error--', error);
        });
        return { ok: true, otpvalid: isOTPSend, response };
      }
    }).catch((error) => {
      console.log('error', error);
      const login = {
        display: true,
        text: `E-mail ou mot de passe incorrect`
      }
      dispatch(setMessage({ login }));
      throw error;
    });

  };
};

export const otpVerify = (data) => {
  return (dispatch) => {
    console.log('-----Auth.js 65----', data);
    return otpVerification(data).then(() => {
      getPartenaire().then((response) => {
        dispatch(setPartenaire(response.data));
        const partnerId = response.data.data.id;
        getBeneficiary(sessionStorage.defaultID).then((response) => {
          const user = {
            uid: uuid(),
            role: response.data.chargeMemoire ? 'MC' : 'AD'
          }
          sessionStorage.setItem('auth', JSON.stringify(user));
          response.data.displayConnexion = true;
          sessionStorage.setItem('benef', JSON.stringify(response.data));
          dispatch(login(user.uid));
          dispatch(setBeneficiary(response.data));
          const headingResp = getStateHeadingData(response.data.idBeneficiaire, partnerId, sessionStorage.defaultID).then((response) => {
            dispatch(getStateHeadings(response.data));
          });
          getCountryData().then((response) => {
            dispatch(setCountry(response.data));
          });
          if (user.role === 'MC') {
            history.push('/#/recap-recueil');
          }
        });
      })
      return { ok: true };
    }).catch((error) => {
      throw error;
    });
  };
};

export const logout = () => ({
  type: 'LOGOUT'
});

export const startLogout = () => {
  return (dispatch) => {
    dispatch(logout());
    sessionStorage.removeItem('auth');
    sessionStorage.removeItem('defaultID');
    history.push("/");
    location.reload();
  };
};







// WEBPACK FOOTER //
// ./src/actions/auth.js